/*
 * @Author: YuanYuan
 * @Date: 2024-02-06 09:51:20
 * @LastEditTime: 2024-12-16 16:00:10
 * @description: 时间相关处理函数集合
 */
import dayjs from 'dayjs'
import { isArray } from 'lodash-es'

// 将当地终端系统时间 time 转化为中台时区对应时间
export const terminalTime2BeijingTime = (time, valueFormat = 'YYYY-MM-DD HH:mm:ss') => {
  if (time) {
    const terminal_offset = -new Date().getTimezoneOffset() / 60 // 终端时区
    const beijing_offset = 8 // 北京时区
    return dayjs(time).add(beijing_offset - terminal_offset, 'h').format(valueFormat)
  }
}

export const beijingTime2TerminalTime = (time, valueFormat = 'YYYY-MM-DD HH:mm:ss') => {
  if (time) {
    const terminal_offset = -new Date().getTimezoneOffset() / 60 // 终端时区
    const beijing_offset = 8 // 北京时区
    return dayjs(time).subtract(beijing_offset - terminal_offset, 'h').format(valueFormat)
  }
}

// 1y -> {num: 1, type: 'y'}
export const timeStr2TimeType = str => {
  const [origin, num, type] = str.match(/^(-?[0-9]+)(y|M|w|d|h|m|s)/)
  return { origin, num: Number(num), type }
}

// 根据快捷键中的value来计算对应时间(转换到中台时区下的时间)
// -1h -> 中台时区对应的最近一小时
const timeStr2Time = value => {
  const { num, type } = timeStr2TimeType(value)
  const current = dayjs()
  switch (type) {
    case 'y':
      return current.set('year', current.year() + num)
    case 'M':
      return current.set('month', current.month() + num)
    case 'w':
      return current.set('day', current.day() + num * 7)
    case 'd':
      return current.set('day', current.day() + num)
    case 'h':
      return current.set('hour', current.hour() + num)
    case 'm':
      return current.set('minute', current.minute() + num)
    case 's':
      return current.set('second', current.second() + num)
  }
}

// 快捷键时区时间范围
const shortcutConsoleTimeRange = (value, extra, valueFormat = 'YYYY-MM-DD HH:mm:ss') => {
  let start, end
  const current = dayjs()
  if (isArray(value)) {
    start = timeStr2Time(value[0])
    end = timeStr2Time(value[1])
  } else {
    const { num } = timeStr2TimeType(value)
    const portal_value = timeStr2Time(value)
    if (num > 0) {
      start = current
      end = portal_value
    } else {
      start = portal_value
      end = current
    }
  }
  // 起始时间是否是凌晨
  if (extra) {
    const startOfType = isArray(extra) ? extra[0] : extra
    const endOfType = isArray(extra) ? extra[1] : extra
    start = start.startOf(startOfType)
    end = end.endOf(endOfType)
  }
  return [dayjs(start).format(valueFormat), dayjs(end).format(valueFormat)]
}

export const timeShortcutsFormatter = (shortcuts = [], valueFormat = 'YYYY-MM-DD HH:mm:ss') => {
  return shortcuts.map(curValue => ({
    text: curValue.text,
    onClick(picker) {
      picker.$emit('pick', shortcutConsoleTimeRange(curValue.value, curValue.extra, valueFormat))
    }
  }))
}

// 时间戳转时间
export const timestampToDatetime = (timestamp, valueFormat = 'YYYY-MM-DD HH:mm:ss') => {
  return dayjs(timestamp).format(valueFormat)
}
